import { render } from "./DeviceList.vue?vue&type=template&id=0d85b842&scoped=true"
import script from "./DeviceList.vue?vue&type=script&lang=js"
export * from "./DeviceList.vue?vue&type=script&lang=js"

import "./DeviceList.vue?vue&type=style&index=0&id=0d85b842&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d85b842"]])

export default __exports__